import { ShopperHomePage } from "./../shopper-home/shopper-home";
import { Storage } from "@ionic/storage";
import { TranslateService } from "@ngx-translate/core";
import { ServiceProvider } from "./../../providers/service/service";
import { RequestOptions, Headers, Http } from "@angular/http";
import { ShopperVotePage } from "./../shopper-vote/shopper-vote";
import { ViewHeaderPage } from "./../view-header/view-header";
import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-shopper-vote-plaza",
  templateUrl: "shopper-vote-plaza.html",
})
export class ShopperVotePlazaPage {
  lists: any;
  theme = 1;

  constructor(
    public navCtrl: NavController,
    private storage: Storage,
    private services: ServiceProvider,
    private http: Http,
    private translateService: TranslateService
  ) {}

  async ionViewDidLoad() {
    this.theme = await this.storage.get("theme");

    this.storage.get("token").then((token) => {
      var link = this.services.URLPlazaList;
      var headers = new Headers();
      headers.append("Accept", "application/json");
      headers.append("Authorization", "Bearer " + token);
      const requestOptions = new RequestOptions({ headers: headers });

      this.http
        .get(link, requestOptions)
        .map((res) => res.json())
        .subscribe(
          (data) => {
            this.lists = data;
          },
          (error) => {
            var response = JSON.parse(error._body);

            this.translateService.get(response.message).subscribe((value) => {
              this.services.presentToast(value);
            });
          }
        );
    });
  }

  select(id) {
    this.navCtrl.push(ShopperVotePage, { plaza_id: id });
  }

  backPage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }

  openHeadPage() {
    this.navCtrl.push(ViewHeaderPage);
  }

  homePage() {
    this.navCtrl.setRoot(ShopperHomePage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/shopper-vote-plaza/shopper-vote-plaza.ts